var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0903 3.96484C12.3797 3.96484 12.5804 3.67224 12.4719 3.40391C12.0865 2.45123 11.1519 1.77734 10.0627 1.77734H9.55916C9.37139 0.785504 8.50177 0 7.43766 0H6.56266C5.49923 0 4.62904 0.784984 4.44117 1.77734H3.93766C2.84844 1.77734 1.91378 2.45123 1.52842 3.40391C1.4199 3.67224 1.62057 3.96484 1.91001 3.96484H12.0903ZM6.56266 0.820312H7.43766C8.03649 0.820312 8.54481 1.2232 8.71593 1.77734H5.28439C5.45551 1.2232 5.96383 0.820312 6.56266 0.820312Z",
    fill: "#181A20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03673 12.8569C3.08237 13.4979 3.62151 14 4.26408 14H9.73614C10.3787 14 10.9179 13.4979 10.9635 12.8569L11.5383 4.78516H2.46191L3.03673 12.8569ZM8.12174 6.97952C8.13306 6.75328 8.32597 6.5788 8.55185 6.59036C8.7781 6.60168 8.95233 6.79427 8.94101 7.02048L8.72226 11.3955C8.7113 11.6147 8.53006 11.7852 8.31295 11.7852C8.07678 11.7852 7.89131 11.5877 7.90296 11.3545L8.12174 6.97952ZM5.4484 6.59036C5.67434 6.57902 5.86722 6.7533 5.87851 6.97952L6.09726 11.3545C6.10891 11.5878 5.9233 11.7852 5.68727 11.7852C5.47016 11.7852 5.28893 11.6147 5.27796 11.3955L5.05921 7.02048C5.04792 6.79427 5.22215 6.60168 5.4484 6.59036Z",
    fill: "#181A20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.4a0ef88dca1c913f236f65f4c821d007.svg";
export { ForwardRef as ReactComponent };